export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_RESPONSE = "LOGIN_RESPONSE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const LOGOUT_RESPONSE = 'LOGOUT_RESPONSE';

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";

export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";